export default __webpack_public_path__ + "static/media/biodata-2.d8c5ae1f.png";